export default function DestinationAddController(
  $state,
  $stateParams,
  $timeout,
  destinationService,
  timezoneService,
  NotificationService,
  slugifyService,
  DESTINATION_TYPES,
  POI_TYPES,
  OPTIONS,
  HTTP_CODE,
) {
  const vm = this,
    WAIT_BEFORE_REDIRECT_TIMEOUT = 1000;

  vm.parentId = $stateParams.parentId;
  vm.citySizes = OPTIONS.destinationSubTypes;
  vm.destinationTypes = DESTINATION_TYPES;
  vm.POI_types = POI_TYPES;
  vm.timezones = null;
  vm.parentDestination = null;
  vm.destination = {};

  vm.init = init;
  vm.getTimezones = getTimezones;
  vm.getParentById = getParentById;
  vm.setDestinationData = setDestinationData;
  vm.addDestination = addDestination;
  vm.updateBrowserUrl = updateBrowserUrl;

  init();

  function init() {
    vm.getTimezones();
  }

  function getTimezones() {
    timezoneService
      .getAllTimezones()
      .then(res => {
        if (res && res.data) {
          vm.timezones = res.data;
        }
      })
      .finally(() => {
        vm.getParentById(vm.parentId);
      });
  }

  function getParentById(parentId) {
    if (!parentId) {
      return;
    }
    destinationService
      .getDestinationById(parentId)
      .then(res => {
        vm.parentDestination = res.data;
        vm.destination.tree = [
          ...vm.parentDestination.tree,
          {
            id: vm.parentDestination.id,
            name: vm.parentDestination.name,
            browserUrl: vm.parentDestination.browserUrl,
          },
        ];
        setDestinationData();
      })
      .catch(res => {
        if (res.status === HTTP_CODE.STATUS.BAD_REQUEST) {
          NotificationService.error('Invalid destination id');
        }
      });
  }

  function setDestinationData() {
    switch (vm.parentDestination.destinationType.id) {
      case vm.destinationTypes.DISTRICT.id:
        vm.destination.countryName = vm.parentDestination.tree[1].name;
        vm.destination.regionName = vm.parentDestination.tree[2].name;
        vm.destination.cityName = vm.parentDestination.tree[3].name;
        vm.destination.latitude = vm.parentDestination.latitude;
        vm.destination.longitude = vm.parentDestination.longitude;
        vm.destination.districtName = vm.parentDestination.name;
        vm.destination.timezone = vm.parentDestination.timezone;
        vm.destination.radius = 1;
        vm.destination.priority = 0;
        vm.destination.description = vm.parentDestination.description;
        vm.destination.type = DESTINATION_TYPES.POI;
        break;
      case vm.destinationTypes.CITY.id:
        vm.destination.countryName = vm.parentDestination.tree[1].name;
        vm.destination.regionName = vm.parentDestination.tree[2].name;
        vm.destination.cityName = vm.parentDestination.name;
        vm.destination.timezone = vm.parentDestination.timezone;
        vm.destination.type = DESTINATION_TYPES.DISTRICT;
        break;
      case vm.destinationTypes.REGION.id:
        vm.destination.countryName = vm.parentDestination.country.name;
        vm.destination.regionName = vm.parentDestination.name;
        vm.destination.type = DESTINATION_TYPES.CITY;
        break;
      case vm.destinationTypes.COUNTRY.id:
        vm.destination.countryName = vm.parentDestination.name;
        vm.destination.type = DESTINATION_TYPES.REGION;
        break;
    }
  }

  function generateAddDestinationDto(destination) {
    return {
      name: destination.name,
      parentId: vm.parentId,
      longitude: destination.longitude || null,
      latitude: destination.latitude || null,
      browserUrl: destination.browserUrl,
      destinationSubType: destination.destinationSubType || null,
      status: 'inactive',
      timezone: destination.timezone || null,
      radius: destination.radius || null,
      //TODO manage priority default value on API
      priority: destination.priority || vm.destination.type.name === vm.destinationTypes.POI.name ? 0 : null,
      description: destination.description || null,
    };
  }

  function addDestination() {
    const destinationDto = generateAddDestinationDto(vm.destination);
    destinationService
      .addDestination(destinationDto)
      .then(res => {
        NotificationService.success('Destination successfully added');
        const destinationId = getDestinationIdFromLocationHeader(res.headers('location'));
        $timeout(() => goToDestinationEditPage(destinationId), WAIT_BEFORE_REDIRECT_TIMEOUT);
      })
      .catch(handleApiError);
  }

  function goToDestinationEditPage(destinationId) {
    $state.go('app.destination.edit', {
      destinationId: destinationId,
      retryOn404: true,
    });
  }

  function updateBrowserUrl() {
    vm.destination.browserUrl = destinationService.getBrowserUrlForDestination(
      vm.destination.name,
      vm.destination.type,
      vm.destination.tree,
    );
  }

  function getDestinationIdFromLocationHeader(locationHeader) {
    return locationHeader.split('/').pop();
  }

  function handleApiError(res) {
    const error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors;
    const errorMessage = error.message ? error.message : 'Adding destination failed';
    NotificationService.error(errorMessage);
  }
}



// WEBPACK FOOTER //
// ./src/app/destinations/destination-add.controller.js